export {Ng2CompleterModule} from './completerModule';

export {CompleterComponent} from './components/completer.component';
export {CompleterListItemComponent} from './components/completer-list-item.component';
export {CompleterService} from './services/completer.service';
export {CompleterData} from './services/completer-data.service';
export {localDataFactory, LocalDataFactoryProvider, remoteDataFactory, RemoteDataFactoryProvider} from './services/data-factory.service';
export {CompleterItem} from './components/completer-item.component';
export {LocalData} from './services/local-data.service';
export {RemoteData} from './services/remote-data.service';
export {CompleterBaseData} from './services/base-data.service';
export {MdbCompleterDirective} from './directives/completer.directive';
export {MdbDropdownDirective} from './directives/dropdown.directive';
export {MdbInputDirective} from './directives/input.directive';
export {MdbListDirective} from './directives/list-context.directive';
export {MdbRowDirective} from './directives/row.directive';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/autocomplete/index.ts